import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RotationMeter from './RotationKpiMeter';
import KpiResult from './KpiResultReview';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as kpiModels from '../../../models/kpiModels';

import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class KpiDashboard extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            lang: this.props.lang,
            userKpisResults: kpiHelper.setKpiRenderOrder(this.props.userKpisResults),
            bite: this.props.bite,
            kpis: kpiHelper.getKpis(this.props.bite),
            showTitle: this.props.showTitle,
            locale: {},
            guid: dataHelper.createGuid(),
            allowUpdates: true,
            updatedKpis: [],
            checkAllUpdated: false,
            performance_label: appHelper.getLocaleString("performance_label")
        };

        this.getKpiLocaleById = this.getKpiLocaleById.bind(this);
        this.getKpiMeterParams = this.getKpiMeterParams.bind(this);
        this.getLocale = this.getLocale.bind(this);
        this.showDashboard = this.showDashboard.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.getKpiItemClass = this.getKpiItemClass.bind(this);
        this.setReviewStateKpiData = this.setReviewStateKpiData.bind(this);
        this.onUpdateComplete = this.onUpdateComplete.bind(this);
    }

    componentDidMount() {
        if (this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED) {
            this.setReviewStateKpiData();
        }
        this.getLocale();
        this.showDashboard();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userKpisResults !== nextProps.userKpisResults) {
            //console.log('update dashboard');
            //this.setState({userKpisResults: kpiHelper.setKpiRenderOrder(nextProps.userKpisResults)});
        }
        if (this.state.showTitle !== nextProps.showTitle) {
            this.setState({showTitle: nextProps.showTitle});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.bite),
                performance_label: appHelper.getLocaleString("performance_label")
            });
        }
    }

    shouldComponentUpdate() {
        return this.state.allowUpdates;
    }

    componentDidUpdate() {

    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.bite);
        this.setState({locale: Object.assign({}, locale)});
    }

    getKpiLocaleById(kpi_id) {
        let kpi = appHelper.getArrayObjectByKey(this.state.bite.kpis, "kpi_id", kpi_id);
        return appHelper.getLocalData(kpi);
    }

    getKpiMeterParams(is_primary) {
        if (is_primary) {
            return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
        } else {
            if (this.state.kpis.length < 3) {
                return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
            } else {
                return kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS;
            }
        }
    }

    setReviewStateKpiData() {
        let primaryKpiIndex = kpiHelper.getPrimaryKpiIndex(this.state.userKpisResults);
        let primaryKpi = kpiHelper.getPrimaryKpi(this.state.userKpisResults);
        let reorderedKpis = dataHelper.immutableSplice(this.state.userKpisResults, primaryKpiIndex, 1);
        reorderedKpis = dataHelper.immutableUnshift(reorderedKpis, primaryKpi);

        this.setState({
            userKpisResults: Object.assign([], reorderedKpis)
        });
    }

    getKpiItemClass(kpi) {
        if (this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL) {
            return `kpi-item inline`;
        } else {
            return `kpi-item-review inline`;
        }

    }

    showDashboard() {

        let optionRef = this.refs[`kpi_dashboard_${this.state.guid}`];
        TweenLite.set(optionRef, {height: "auto"});
        TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
            height: 0,
            ease: Expo.linear
        }).eventCallback("onComplete", this.onComplete);
    }

    onComplete() {
        if (!this.props.responseReview) {
            this.setState({allowUpdates: false});
        }

        if (typeof this.props.onComplete !== 'undefined') {
            this.props.onComplete();
        }
    }

    onUpdateComplete(kpi_id) {
        let kpi_idIndex = appHelper.getArrayObjectIndexByKey(this.state.updatedKpis, "kpi_id", kpi_id);
        if (kpi_idIndex === -1) {
            this.setState({updatedKpis: dataHelper.immutablePush(this.state.updatedKpis, kpi_id)});
        }
        if ((this.state.updatedKpis.length >= this.state.userKpisResults.length) && appHelper.isDefined(this.props.onUpdateComplete)) {
            this.props.onUpdateComplete();
        }
    }

    render() {
        return (
            <div className="kpi-dashboard" ref={`kpi_dashboard_${this.state.guid}`} >

                {
                    this.state.showTitle
                        ? <h4 className="text-center">{this.state.performance_label}</h4>
                        : null
                }

                <div className="object-container">
                    <ul className={`inline-list ${!this.props.responseReview ? `text-center` : ``}`}>
                        {this.state.userKpisResults.map(kpi =>

                            ( (appHelper.isDefined(this.props.hideScoreKpi) && this.props.hideScoreKpi && !kpi.is_primary) || (!appHelper.isDefined(this.props.hideScoreKpi)) || (appHelper.isDefined(this.props.hideScoreKpi) && !this.props.hideScoreKpi)) && this.props.responseReview && (appHelper.isDefined(appHelper.getArrayObjectByKey(this.state.kpis, "kpi_id", kpi.kpi_id)) &&appHelper.getArrayObjectByKey(this.state.kpis, "kpi_id", kpi.kpi_id).is_visible)
                                ?
                                <li className={`inline-item ${this.getKpiItemClass(kpi)}`}
                                    key={`${kpi.kpi_id}_${dataHelper.createGuid()}`}>
                                    <KpiResult
                                        kpiDefaults={appHelper.getArrayObjectByKey(this.state.kpis, "kpi_id", kpi.kpi_id)}
                                        meterParams={this.getKpiMeterParams(false)}
                                        kpi={appHelper.getArrayObjectByKey(this.props.option.kpis, "kpi_id", kpi.kpi_id)}/>
                                </li>

                                :
                                null
                        )}
                        {this.state.userKpisResults.map(kpi =>

                            !this.props.responseReview && appHelper.isDefined(appHelper.getArrayObjectByKey(this.state.kpis, "kpi_id", kpi.kpi_id)) && (appHelper.isDefined(appHelper.getArrayObjectByKey(this.state.kpis, "kpi_id", kpi.kpi_id)) && appHelper.getArrayObjectByKey(this.state.kpis, "kpi_id", kpi.kpi_id).is_visible)
                                ?
                                <li className={`inline-item ${this.getKpiItemClass(kpi)}`}
                                    key={`${kpi.kpi_id}_${dataHelper.createGuid()}`}>
                                    <RotationMeter bite_id={this.state.bite.bite_id}
                                                   kpiDefaults={appHelper.getArrayObjectByKey(this.state.kpis, "kpi_id", kpi.kpi_id)}
                                                   index={appHelper.getArrayObjectIndexByKey(this.state.kpis, "kpi_id", kpi.kpi_id)}
                                                   showImmediateImpact={this.props.showImmediateImpact}
                                                   meterParams={this.getKpiMeterParams(kpi.is_primary)}
                                                   displayState={this.props.displayState}
                                                   responseReview={this.props.responseReview}
                                                   screen_id={this.props.screen_id}
                                                   asset_id={this.props.asset_id}
                                                   option_id={typeof this.props.option !== "undefined" ? this.props.option.option_id : 0}
                                                   onRotationComplete={this.onUpdateComplete}/>
                                </li>
                                :
                                null
                        )}
                    </ul>
                </div>
            </div>
        );
    }
}

KpiDashboard.propTypes = {
    displayState: PropTypes.string.isRequired,
    bite_id: PropTypes.number.isRequired,
    showTitle: PropTypes.bool.isRequired,
    lang: PropTypes.string.isRequired,
    bite: PropTypes.object,
    responseReview: PropTypes.bool,
    screen_id: PropTypes.number,
    asset_id: PropTypes.number,
    option: PropTypes.object,
    showImmediateImpact: PropTypes.bool,
    userKpisResults: PropTypes.array,
    onComplete: PropTypes.func,
    onUpdateComplete: PropTypes.func,
    hideScoreKpi: PropTypes.bool,

};

KpiDashboard.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let userBite = appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id);
    let bite = appHelper.getBite(ownProps.bite_id);
    let userKpisResults = userBite.kpis;

    let lang = state.userData.lang;
    return {
        lang:lang,
        userKpisResults: userKpisResults,
        bite: bite
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(KpiDashboard);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiDashboard.js
 **/